<div class="input-parent" [ngClass]="{'float-label': typeLabel === 'float'}">
  <span [ngClass]="{'ui-float-label': typeLabel === 'float'}">
    <label
          *ngIf="typeLabel !== 'float' && label !== ''"
          [ngClass]="{
           'input-label':checkEmptyInput(controlForm),
           'error-label':controlForm.invalid && (displayErrorDynamic || (controlForm.dirty || controlForm.touched))
       }"
          translate>
      {{label}}
    </label>
    <input
      [autocomplete]="autocomplete"
      [formControl]="controlForm"
      [ngClass]="{'error-input': controlForm.invalid && (displayErrorDynamic || (controlForm.dirty || controlForm.touched))}"
      [type]="typeInput"
      placeholder="{{ placeHolder | translate }}"
      class="form-control input" pInputText required>
    <label
      *ngIf="typeLabel === 'float' && label !== ''"
      [ngClass]="{
           'input-label':checkEmptyInput(controlForm),
           'error-label':controlForm.invalid && (displayErrorDynamic || (controlForm.dirty || controlForm.touched))
       }"
      translate>
      {{label}}
    </label>
  </span>
</div>
